import { Box } from '@material-ui/core';

export interface IOrderItem {
  name: string;
  price: string;
  totalItems: number;
  images: string[];
  handleClick: () => void;
}

export const OrderItem: React.FC<IOrderItem> = ({
  name,
  price,
  totalItems,
  images,
  handleClick,
}) => (
  <Box display="flex" justifyContent="space-between">
    <Box display="flex">
      <img
        src={images[0]}
        alt={name}
        style={{
          objectFit: 'contain',
          width: '100%',
          height: '100%',
          maxWidth: '48px',
          borderRadius: '8px',
          border: '1px solid var(--b2chat-gray-400)',
        }}
      />
      <Box ml="20px">
        <Box
          color="#000"
          fontSize={14}
          fontWeight={500}
          onClick={handleClick}
          style={{ cursor: 'pointer' }}
        >
          {name}
        </Box>
        <Box fontSize={12}>{price}</Box>
      </Box>
    </Box>
    <Box color="#000" fontSize="15.637px" fontWeight={700}>
      {totalItems}
    </Box>
  </Box>
);

export default OrderItem;
